import useIntegrations from './hooks/useIntegrations';
import IntegrationsView from './view';

export default function Integrations({ info }) {
    const props = useIntegrations(info);
    return <IntegrationsView {...props} />;
}
